<template>
  <div class="close-content">
    <img
      class="close-toast"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c020935b4853d59918f18d9275f1e5ee.png"
      alt=""
    />
    <div class="cancel" @click="bindCancel"></div>
    <div class="confirm" @click="bindConfirm"></div>
    <div class="close iconfont icon-cha" @click="bindCancel"></div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {
    bindCancel() {
      this.$emit('cancel')
    },
    bindConfirm() {
      this.$emit('confirm')
    }
  }
}
</script>
<style lang="scss" scoped>
.close-content {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .close-toast {
    width: 280px;
  }
  .cancel {
    width: 240px;
    height: 44px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0%);
    bottom: 50px;
  }
  .confirm {
    width: 100px;
    height: 30px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0%);
    bottom: 10px;
  }
  .close {
    border: 1px solid #fff;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0%);
    bottom: -54px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
  }
}
</style>
